import { defineMessages } from 'react-intl'

export default defineMessages({
  menuLabel: {
    id: 'cp.components.navBar.menuLabel',
    defaultMessage: 'menu',
  },
})
